import { Globe, Sparkles, TriangleAlert } from "lucide-react";
import "./OrderBadges.scss";

/**
 * Odznaky objednávky — spoločné pre Dashboard aj Prehľad (R3, R3a, R24, R42).
 *
 * Prečo vlastný komponent: tie isté štyri odznaky potrebujú dve obrazovky
 * a dispečer ich musí čítať rovnako na oboch. Dve kópie by sa časom rozišli
 * farbou aj poradím a človek by si ich musel prekladať.
 *
 * Poradie je zámerné — zľava to, čo si vyžaduje pozornosť najskôr:
 *   BEZ TRASY → objednávka sa nedá doručiť, kým ju dispečer nepriradí (R3b)
 *   NOVÝ → zákazník, ktorému sa ešte nikdy nič nedoručilo (R24)
 *   WEB → zadal si ju zákazník sám
 *
 * Odznak „NA PREVÁDZKE“ tu zámerne NIE JE: odber na prevádzke má vlastnú
 * trasu výdaja a tá je na karte vidieť aj farbou. Dva znaky pre tú istú vec
 * len zaberali miesto adrese.
 */
function OrderBadges({ order, className = "" }) {
  if (!order) return null;

  const naPrevadzke = order.delivery_type === "PICKUP";
  // Odber na prevádzke trasu nepotrebuje — "bez trasy" by pri ňom bola
  // falošná výstraha.
  const bezTrasy = !naPrevadzke && !order.route_id;
  const zWebu = order.source === "WEB";
  const novy = order.customer_is_new === true;

  if (!bezTrasy && !zWebu && !novy) return null;

  return (
    <span className={`order-badges ${className}`.trim()}>
      {bezTrasy && (
        <span className="order-badges__badge order-badges__badge--bez-trasy" title="Objednávka nemá pridelenú trasu, takže sa nedá doručiť">
          <TriangleAlert size={11} aria-hidden="true" /> BEZ TRASY
        </span>
      )}
      {novy && (
        <span className="order-badges__badge order-badges__badge--novy" title="Tomuto zákazníkovi sa ešte nikdy nič nedoručilo">
          <Sparkles size={11} aria-hidden="true" /> NOVÝ
        </span>
      )}
      {zWebu && (
        <span className="order-badges__badge order-badges__badge--web" title="Objednávku si zadal zákazník sám cez web">
          <Globe size={11} aria-hidden="true" /> WEB
        </span>
      )}
    </span>
  );
}

export default OrderBadges;
